/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { useRef } from "react";
import PropTypes from "prop-types";

function ReceiptEditorToolbar({
  onAddText,
  onAddImage,
  onSave,
  onReset,
  onSendTest,
  loading,
  dirty,
  textObj = {}
}) {
  const fileInputRef = useRef(null);
  const t = (key, fallback) => textObj[key] || fallback;

  const handleImageClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onAddImage(file);
      // Reset so the same file can be re-selected
      e.target.value = "";
    }
  };

  return (
    <div className="ReceiptEditorToolbar-bar">
      <button
        type="button"
        className="ReceiptEditorToolbar-btn"
        onClick={onAddText}
        disabled={loading}
      >
        {t("addText", "+ Add Text")}
      </button>

      <button
        type="button"
        className="ReceiptEditorToolbar-btn"
        onClick={handleImageClick}
        disabled={loading}
      >
        {t("addImage", "+ Add Image")}
      </button>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/png,image/jpeg"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      <button
        type="button"
        className="ReceiptEditorToolbar-btn ReceiptEditorToolbar-btn--reset"
        onClick={onReset}
        disabled={loading}
      >
        {t("resetToDefault", "Reset to Default")}
      </button>

      <button
        type="button"
        className="ReceiptEditorToolbar-btn ReceiptEditorToolbar-btn--save"
        onClick={onSave}
        disabled={loading || !dirty}
      >
        {loading ? t("saving", "Saving...") : t("saveLayout", "Save Layout")}
      </button>

      <button
        type="button"
        className="ReceiptEditorToolbar-btn ReceiptEditorToolbar-btn--test"
        onClick={onSendTest}
        disabled={loading}
      >
        {t("sendTestReceipt", "Send Test Receipt")}
      </button>
    </div>
  );
}

ReceiptEditorToolbar.propTypes = {
  onAddText: PropTypes.func.isRequired,
  onAddImage: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onSendTest: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  dirty: PropTypes.bool,
  textObj: PropTypes.object
};

export default ReceiptEditorToolbar;
